import { get, post, put } from '../../../helpers/api'
import { api } from '../api'
import {
  SET_MEMBER_DATA,
  SET_MEMBER_ENROLLMENT_RANK_LIST,
  SET_MEMBER_HIGHEST_RANK_LIST,
  SET_MEMBER_LIST_DATA,
  SET_MEMBER_LIST_SEARCH_DATA,
  SET_MEMBER_MIGRATION_LIST_DATA,
  SET_MEMBER_NEXT_PLACEMENT_POSITION,
  SET_MEMBER_RANK_LIST_DATA,
  SET_MEMBER_SALES_HISTORY_LIST_DATA,
  SET_MEMBER_TABS_DATA,
  SET_MEMBER_TRANSACTION_LIST_DATA,
  SET_MEMBER_TREE,
  SET_MEMBERS_MULTI_FUNCTIONAL_TREE,
  SET_MEMBERS_ON_BEHALF_TOKEN,
  SET_MEMBERS_STATUS_LIST,
  SET_MEMBERS_TREE,
  SHOW_NOTIFICATION,
  UNSET_MEMBER_DATA,
  SET_MEMBER_COUNCIL_RANK_LIST,
  SET_MEMBER_PERFORMANCE_DATA,
  SET_MEMBER_SPONSOR_LISTING_DATA,
  SET_MEMBER_SPONSOR_LISTING_FILTERS_DATA,
  SET_QUEUE_REQUEST_RESPONSE,
} from 'src/store/types'

export const getMembersTreeAction = ({ commit }, query) => {
  return new Promise(resolve => {
    get(api.memberPlacementTree, query).then(response => {
      const json = response.data
      commit(SET_MEMBERS_TREE, {
        memberTree: json,
      })
      resolve(response.data)
    })
  })
}

export const getMemberTabsData = ({ commit }, query) => {
  return new Promise(resolve => {
    post(api.memberTabs, query).then(response => {
      const json = response.data
      commit(SET_MEMBER_TABS_DATA, {
        data: json,
      })

      resolve(response.data)
    })
  })
}

export const getMemberByUserIdAction = ({ commit, dispatch }, query) => {
  return new Promise((resolve, reject) => {
    post(api.memberDetails, query)
      .then(response => {
        const json = response.data.member_data
        commit(SET_MEMBER_DATA, {
          data: json,
        })
        resolve(response.data)
      })
      .catch(error => {
        dispatch('unsetMemberDataAction')
        reject(error)
      })
  })
}

export const updateMemberAction = ({ commit }, data) => {
  return new Promise((resolve, reject) => {
    // Remove if parent not selected to avoid validation error
    put(api.member + '/' + data.member_data.details.user_id, data)
      .then(response => {
        commit(SHOW_NOTIFICATION, { title: 'Member Data Saving', message: 'operation.success', type: 'positive' })
        resolve(response.data)
      })
      .catch(error => {
        reject(error)
      })
  })
}

export const getMemberListingAction = ({ commit }, query) => {
  return new Promise(resolve => {
    post(api.members, query).then(response => {
      const json = response.data
      commit(SET_MEMBER_LIST_DATA, {
        list: json,
      })

      resolve(response.data)
    })
  })
}

export const getMemberTreeAction = ({ commit }, query) => {
  return new Promise((resolve, reject) => {
    post(api.memberPlacementTree, query)
      .then(response => {
        const json = response.data
        commit(SET_MEMBER_TREE, {
          memberTree: json,
        })

        resolve(response.data)
      })
      .catch(error => {
        commit(SET_MEMBER_TREE, {
          memberTree: {},
        })
        reject(error.response.data)
      })
  })
}

export const sendMemberPassword = ({ commit }, query) => {
  return new Promise(resolve => {
    post(api.memberPasswordReset, query).then(response => {
      commit(SHOW_NOTIFICATION, { title: 'Member Password Reset', message: 'Operation success', type: 'positive' })
      resolve(response.data)
    })
  })
}

export const getMembersOuterTreeAction = ({ commit }, query) => {
  return new Promise((resolve, reject) => {
    post(api.memberPlacementOuterTree, query)
      .then(response => {
        const json = response.data
        commit(SET_MEMBER_TREE, {
          memberTree: json,
        })
        resolve(response.data)
      })
      .catch(error => {
        commit(SET_MEMBER_TREE, {
          memberTree: {},
        })
        reject(error)
      })
  })
}

export const getMemberMultiFunctionalTreeAction = ({ commit }, query) => {
  return new Promise(resolve => {
    post(api.memberTree, query).then(response => {
      const json = response.data
      commit(SET_MEMBERS_MULTI_FUNCTIONAL_TREE, {
        list: json,
      })

      resolve(response.data)
    })
  })
}

export const getMemberRankListDataAction = ({ commit }, query) => {
  return new Promise(resolve => {
    post(api.memberRankList, query).then(response => {
      const json = response.data
      commit(SET_MEMBER_RANK_LIST_DATA, {
        data: json,
      })

      resolve(response.data)
    })
  })
}

export const updateMemberRankAction = ({ commit }, data) => {
  return new Promise(resolve => {
    post(api.memberRankUpdate, data).then(response => {
      commit(SHOW_NOTIFICATION, { title: 'Update Member Rank', message: 'Operation success', type: 'positive' })

      resolve(response.data)
    })
  })
}

export const getMemberHighestRankAction = ({ commit }, query) => {
  return new Promise(resolve => {
    post(api.memberHighestRank, query).then(response => {
      const json = response.data.data
      commit(SET_MEMBER_HIGHEST_RANK_LIST, {
        list: json.map(opt => ({ label: opt.rank_name, value: opt.id })),
      })
      resolve(response.data)
    })
  })
}

export const getMemberEnrollmentRankAction = ({ commit }, query) => {
  return new Promise(resolve => {
    post(api.memberEnrollmentRank, query).then(response => {
      const json = response.data.data
      commit(SET_MEMBER_ENROLLMENT_RANK_LIST, {
        list: json.map(opt => ({ label: opt.rank_code, value: opt.id })),
      })
      resolve(response.data)
    })
  })
}

export const getMemberMigrationListAction = ({ commit }, query) => {
  return new Promise(resolve => {
    post(api.memberMigrationList, query).then(response => {
      const json = response.data
      commit(SET_MEMBER_MIGRATION_LIST_DATA, {
        data: json,
      })

      resolve(response.data)
    })
  })
}

export const updateMemberMigrationAction = ({ commit }, data) => {
  return new Promise(resolve => {
    post(api.memberMigrationUpdate, data).then(response => {
      commit(SHOW_NOTIFICATION, { title: 'Update Member Migration', message: 'Operation success', type: 'positive' })

      resolve(response.data)
    })
  })
}

export const getMemberStatusListDataAction = ({ commit }, query) => {
  return new Promise(resolve => {
    post(api.memberStatusList, query).then(response => {
      const json = response.data
      commit(SET_MEMBERS_STATUS_LIST, {
        data: json,
      })

      resolve(response.data)
    })
  })
}

export const updateMemberStatusAction = ({ commit }, data) => {
  return new Promise(resolve => {
    post(api.memberStatusUpdate, data).then(response => {
      commit(SHOW_NOTIFICATION, { title: 'Update Member Status', message: 'Operation success', type: 'positive' })

      resolve(response.data)
    })
  })
}

export const getMemberTransactionListDataAction = ({ commit }, query) => {
  return new Promise(resolve => {
    post(api.memberWalletTransactions, query).then(response => {
      const json = response.data
      commit(SET_MEMBER_TRANSACTION_LIST_DATA, {
        data: json,
      })

      resolve(response.data)
    })
  })
}

export const getMemberSalesHistoryListAction = async ({ commit, dispatch }, query) => {
  return new Promise(resolve => {
    post(api.memberSalesHistory, query).then(response => {
      const json = response.data
      commit(SET_MEMBER_SALES_HISTORY_LIST_DATA, {
        list: json,
      })
      resolve(response.data)
    })
  })
}

export const getMembersOnBehalfToken = ({ commit }, query) => {
  return new Promise(resolve => {
    get(api.memberOnBehalfToken + query.user_id).then(response => {
      const json = response.data
      commit(SET_MEMBERS_ON_BEHALF_TOKEN, {
        data: json,
      })

      resolve(response.data)
    })
  })
}

export const getMemberNextPlacementAction = ({ commit }, query) => {
  return new Promise(resolve => {
    get(api.memberNextPlacement + query.user_id).then(response => {
      const json = response.data
      commit(SET_MEMBER_NEXT_PLACEMENT_POSITION, { data: json })
      resolve(response.data)
    })
  })
}

export const unsetMemberDataAction = ({ commit }) => {
  commit(UNSET_MEMBER_DATA)
}

export const getCouncilRankListAction = ({ commit }, query) => {
  return new Promise(resolve => {
    get(api.memberCouncilRankList, query).then(response => {
      let labelText = query.label ? query.label : 'name'
      const json = response.data.data
      commit(SET_MEMBER_COUNCIL_RANK_LIST, {
        list: json.map(opt => ({ label: opt[labelText], value: opt.id })),
      })
      resolve(response.data)
    })
  })
}

export const getDownlineMemberPerformanceAction = ({ commit, dispatch }, query) => {
  return new Promise((resolve, reject) => {
    post(api.memberPerformance, query).then(response => {
      const json = response.data
      commit(SET_MEMBER_PERFORMANCE_DATA, {
        list: json,
      })
      resolve(response.data)
    })
  })
}

export const downloadDownlineMemberPerformanceAction = ({ commit, dispatch }, query) => {
  return new Promise(resolve => {
    post(api.memberPerformanceDownload, query).then(response => {
      resolve(response.data)
    })
  })
}

export const getSponsorDownlineListingAction = ({ commit }, query) => {
  return new Promise(resolve => {
    post(api.memberSponsorDownlineListing, query).then(response => {
      commit(SET_QUEUE_REQUEST_RESPONSE, response.data)
      resolve(response.data)
    })
  })
}

export const getSponsorDownlineListingFiltersAction = ({ commit }) => {
  return new Promise(resolve => {
    get(api.memberSponsorDownlineListingFilters).then(response => {
      const json = response.data
      commit(SET_MEMBER_SPONSOR_LISTING_FILTERS_DATA, {
        list: json,
      })

      resolve(response.data)
    })
  })
}
